import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <AppSection />
        <AboutSection />
        <FaqSection />
        <CarouselSection />
        <ContactSection />
        <CommentsSection />
        <UpdatesSection />
        <IndexSection />
        <CardsSection />
        <FeaturesSection />
        <TopicsSection />
        <MediaSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}